// When the Code Routage field has a value, the SIRET field becomes mandatory.

var SIRET_SELECTOR = "#registration-form-siret";
var ROUTAGE_SELECTOR = "#registration-form-routage";
var SIRET_TAB_SELECTOR = "#siret-tab";

// A valid SIRET number is composed of exactly 14 digits.
var SIRET_FORMAT_REGEX = /^\d{14}$/;

// Show the SIRET tab.
function activateSiretTab() {
    var $tab = $(SIRET_TAB_SELECTOR);
    if ($tab.length) {
        $tab.trigger("click");
    }
}

// Show an error on the SIRET field with the given message.
function showSiretError($siret, message) {
    var siretEl = $siret.get(0);
    if (!siretEl) {
        return;
    }
    var errorMessage = message || $siret.data("routage-required-error") || "";
    siretEl.setCustomValidity(errorMessage);
    $siret.addClass("is-invalid");
    $siret.parents(".form-group").find(".invalid-feedback").text(errorMessage);
}

// Clear the error from the SIRET field.
function clearSiretError($siret) {
    var siretEl = $siret.get(0);
    if (!siretEl) {
        return;
    }
    siretEl.setCustomValidity("");
    $siret.removeClass("is-invalid");
    $siret.parents(".form-group").find(".invalid-feedback").empty();
}

// Toggle the SIRET error based on the routage/siret values.
function updateSiretValidity($siret, $routage) {
    var siretValue = $.trim($siret.val());
    var routageHasValue = $.trim($routage.val()).length > 0;
    var siretHasValue = siretValue.length > 0;

    if (routageHasValue && !siretHasValue) {
        showSiretError($siret);
    } else if (siretHasValue && !SIRET_FORMAT_REGEX.test(siretValue)) {
        // On top of the existing rules, a filled SIRET must be exactly 14 digits.
        var formatMessage = $siret.data("siret-format-error") || "";
        showSiretError($siret, formatMessage);
    } else if (!routageHasValue || (routageHasValue && siretHasValue)) {
        clearSiretError($siret);
    }
}

module.exports = function () {
    var $siret = $(SIRET_SELECTOR);
    var $routage = $(ROUTAGE_SELECTOR);

    if (!$siret.length || !$routage.length) {
        return;
    }

    var revalidate = function () {
        updateSiretValidity($siret, $routage);
    };

    $siret.on("input change blur", revalidate);
    $routage.on("input change blur", revalidate);

    // On submit, native validation fires "invalid" (not the form's "submit").
    // Switch to the SIRET tab and re-apply the error, then scroll/focus it.
    $siret.on("invalid", function () {
        activateSiretTab();
        window.setTimeout(function () {
            updateSiretValidity($siret, $routage);
            var siretEl = $siret.get(0);
            if (siretEl && typeof siretEl.scrollIntoView === "function") {
                siretEl.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            $siret.trigger("focus");
        }, 0);
    });
};
